import { AppConstants } from "@/common";
import { VodPagingRequestData } from "@ca.vmedia.tv/domains";
import { useMostPopularVod } from "@/stores/MostPopularVod";
import { useLinesVodStore } from "@/stores/LinesVod";
import { useUserInfoStore } from "@/stores/UserInfo";
import { storeToRefs } from 'pinia';
import { useVodPageStore } from "@/stores/VodPage";


const {
    fetchMostPopularVod
} = useMostPopularVod();
const {
	fetchInternalGenres,
} = useLinesVodStore();

const {
	fetchNewShows,
	fetchNewMovies,
	fetchRecommendedShows,
	fetchRecommendedMovies,
	fetchContinueWatching,
	fetchMostPopular,
	fetchNewReleases,
	fetchWatchAgain
} = useVodPageStore();


const UserInfoStoreModule = useUserInfoStore();
const {
	isGuest,
} = storeToRefs(UserInfoStoreModule);

export default defineNuxtRouteMiddleware(() => {
	if (import.meta.client) {
		const { lineViewRows } = useAppConfig();

		void fetchMostPopularVod(new VodPagingRequestData(AppConstants.MostPopularItemsInLine,1));

		void fetchNewShows();

		void fetchNewMovies();

		if (!isGuest.value) {
			void fetchRecommendedShows();

			void fetchRecommendedMovies();
		}

		void fetchContinueWatching();

		void fetchMostPopular();

		void fetchNewReleases();
		
		if (lineViewRows.vod.includes(AppConstants.shelfKeys.vodWatchAgainCards)) {
			void fetchWatchAgain();
		}
		
		void fetchInternalGenres();
	}
});